import React, { useEffect } from 'react'
import { CardHeader, Grid, Typography, Box } from '@mui/material'
import { CompError, CompPedido } from '../../Complex/'
import { IoChevronBackOutline } from 'react-icons/io5'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { useLocation } from 'react-router-dom'
import { Services } from '../../../services'
import useHoraFixa from './HoraFixa.functions.ts'
import { Loading } from '../../Simple'
import RouterHook from '../../../contexts/RouterHook'
import moment from 'moment'

export default function MobileHF() {
  const location = useLocation()
  const serverRouter = RouterHook()
  const { sttCtxAgend, loadAgend } = React.useContext(AgendamentoContext)
  const { BuscarHoraFixaId, verificarAcessoUsuario, semAcesso } = useHoraFixa()

  useEffect(() => {
    BuscarHoraFixaId(location.pathname.split('/').pop()).then(horariosFixos => {
      verificarAcessoUsuario(horariosFixos)
    })
  }, [])

  function ReturnVigenciaHf(hf) {
    if (hf.tipoMensalista === 'Indeterminado') {
      return `Sem fim, começou em ${moment(hf.dataPrimeiraReserva).format('DD/MM/YY')}`
    } else {
      return `${moment(hf.dataPrimeiraReserva).format('DD/MM/YY')} até ${moment(hf.dataUltimaReserva).format('DD/MM/YY')}`
    }
  }

  return (
    <>
      {loadAgend.horaFixa ? (
        <div className='contain-loading'>
          <Loading text={'Carregando mensalista...'} />
        </div>
      ) : semAcesso ? (
        <CompError
          title='Horário Fixo não encontrado'
          message='O horário fixo que você está tentando acessar não existe.'
        />
      ) : (
        <div className='contain-page-mobile'>
          <CardHeader
            sx={{
              padding: '10px',
              '& .MuiCardHeader-avatar': {
                marginRight: '5px',
              },
            }}
            avatar={
              <IoChevronBackOutline
                className='icon-back-page'
                onClick={() => {
                  serverRouter('back')
                }}
              />
            }
            title={
              <Typography variant='body1' className='text-title-page'>
                Horário Fixo
              </Typography>
            }
            subheader={
              <Typography variant='body2' className='text-sub-title'>
                {`Nº #${location.pathname.split('/').pop()}`}
              </Typography>
            }
          />
          <Box
            sx={{
              ...stMob.containTopo,
            }}
          >
            <Typography variant='body1' sx={stMob.subTitle}>
              Detalhes do Contrato
            </Typography>
            <Grid container spacing={0} sx={{ padding: '0px 0px 0px 10px', marginBottom: '5px' }}>
              <Grid item xs={3}>
                <Typography variant='body2' sx={stMob.labelLeft}>
                  Local
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography variant='body2' sx={stMob.labelRight}>
                  {sttCtxAgend.horaFixaSelected?.quadra.descricao}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant='body2' sx={stMob.labelLeft}>
                  Dia
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography variant='body2' sx={stMob.labelRight}>
                  {Services.ReturnDiaSemana(
                    4,
                    new Date(sttCtxAgend.horaFixaSelected?.dataPrimeiraReserva),
                  )}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant='body2' sx={stMob.labelLeft}>
                  Horário
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography variant='body2' sx={stMob.labelRight}>
                  {`${Services.ReturnHoraMin(sttCtxAgend.horaFixaSelected.pedidos[0].dataInicio)} às ${Services.ReturnHoraMin(
                    sttCtxAgend.horaFixaSelected?.pedidos[0].dataFinal,
                  )}`}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant='body2' sx={stMob.labelLeft}>
                  Vigência
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography variant='body2' sx={stMob.labelRight}>
                  {ReturnVigenciaHf(sttCtxAgend.horaFixaSelected)}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  variant='body2'
                  sx={{ ...stMob.labelLeft, fontFamily: 'jost-mediun', fontWeight: 'bold' }}
                >
                  Situação
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography variant='body2' sx={stMob.labelRight}>
                  {sttCtxAgend.horaFixaSelected?.status ? 'ATIVO' : 'INATIVO'}
                </Typography>
              </Grid>
            </Grid>
            <Typography variant='body1' sx={stMob.subTitle}>
              Valores
            </Typography>
            <Grid container spacing={0} sx={{ padding: '0px 0px 0px 10px', marginBottom: '5px' }}>
              <Grid item xs={6}>
                <Typography variant='body2' sx={stMob.labelLeft}>
                  Total contratado
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='body2' sx={stMob.labelRight}>
                  {Services.FormatValor(sttCtxAgend.horaFixaSelected?.valorAtualizado)}
                </Typography>
              </Grid>
              {sttCtxAgend.horaFixaSelected?.valorCancelado > 0 && (
                <>
                  <Grid item xs={6}>
                    <Typography variant='body2' sx={stMob.labelLeft}>
                      Total cancelado
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='body2' sx={{ ...stMob.labelRight, color: '#db644f' }}>
                      {Services.FormatValor(sttCtxAgend.horaFixaSelected?.valorCancelado)}
                    </Typography>
                  </Grid>
                </>
              )}
              {sttCtxAgend.horaFixaSelected?.valorRealizado > 0 && (
                <>
                  <Grid item xs={6}>
                    <Typography variant='body2' sx={stMob.labelLeft}>
                      Total pago
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant='body2' sx={{ ...stMob.labelRight, color: '#21c277' }}>
                      {Services.FormatValor(sttCtxAgend.horaFixaSelected?.valorRealizado)}
                    </Typography>
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <Typography variant='body2' sx={stMob.labelCenter}>
                  Os valores do contrato são atualizados automaticamente
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={stMob.containBotton}>
            {/* <Box>
              <div
                className='rtz-banner'
                data-rtz-espaco-id='119'
                style={{ width: '320px', height: '100px', overflow: 'hidden' }}
                data-rtz-width='320'
                data-rtz-height='100'
                title='Espaço publicitário'
                data-rtz-display-formato='imagem_video'
                data-rtz-tipo-criativo='360'
                data-rtz-device='mobile'
              ></div>
            </Box> */}
            {sttCtxAgend.horaFixaSelected?.pedidos.length > 0 ? (
              sttCtxAgend.horaFixaSelected?.pedidos.map((pedido, index) => (
                <React.Fragment key={index}>
                  <CompPedido pedido={pedido} />
                </React.Fragment>
              ))
            ) : (
              <Typography variant='body2' sx={stMob.labelCenter}>
                Nenhum pedido encontrado
              </Typography>
            )}
          </Box>
        </div>
      )}
    </>
  )
}

const stMob = {
  containTopo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '5px 10px',
    borderBottom: '1px solid #d9d9d9',
    boxShadow: '0px 5px 10px -5px rgba(0, 0, 0, 0.2)',
    backgroundColor: 'white',
    borderRadius: '0px 0px 20px 20px',
  },
  containBotton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '5px 10px',
    overflow: 'auto',
  },
  subTitle: {
    width: '100%',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#ff7043',
    marginBottom: '5px',
  },
  labelLeft: {
    width: 'auto',
    fontSize: '14px',
    fontWeight: 'bold',
    color: 'gray',
  },
  labelRight: {
    width: '100%',
    fontSize: '15px',
    fontWeight: 'bold',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  labelCenter: {
    width: '100%',
    fontSize: '12px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: '7px',
    color: 'gray',
  },
}
